const RequirementsIcon = (props) => {
  const { color = 'currentColor' } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 20 20"
      fill="none"
    >
      <mask
        id="mask0_2_984"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="20"
        height="20"
      >
        <rect width="20" height="20" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2_984)">
        <path
          d="M7.75646 14.7917V13.7083H16.5833V14.7917H7.75646ZM7.75646 10.5417V9.45833H16.5833V10.5417H7.75646ZM7.75646 6.29166V5.20833H16.5833V6.29166H7.75646ZM4.63188 15.4696C4.29521 15.4696 4.00855 15.3497 3.77188 15.11C3.53507 14.8703 3.41667 14.5821 3.41667 14.2456C3.41667 13.909 3.53653 13.6223 3.77625 13.3856C4.01598 13.1488 4.3041 13.0304 4.64063 13.0304C4.9773 13.0304 5.26396 13.1503 5.50063 13.39C5.73744 13.6297 5.85584 13.9178 5.85584 14.2544C5.85584 14.591 5.73598 14.8777 5.49626 15.1144C5.25653 15.3512 4.96841 15.4696 4.63188 15.4696ZM4.63188 11.2196C4.29521 11.2196 4.00855 11.0997 3.77188 10.86C3.53507 10.6203 3.41667 10.3321 3.41667 9.99562C3.41667 9.65895 3.53653 9.37229 3.77625 9.13562C4.01598 8.89881 4.3041 8.78041 4.64063 8.78041C4.9773 8.78041 5.26396 8.90027 5.50063 9.13999C5.73744 9.37972 5.85584 9.66784 5.85584 10.0044C5.85584 10.341 5.73598 10.6277 5.49626 10.8644C5.25653 11.1012 4.96841 11.2196 4.63188 11.2196ZM4.63188 6.96958C4.29521 6.96958 4.00855 6.84972 3.77188 6.60999C3.53507 6.37027 3.41667 6.08215 3.41667 5.74562C3.41667 5.40895 3.53653 5.12229 3.77625 4.88562C4.01598 4.64881 4.3041 4.53041 4.64063 4.53041C4.9773 4.53041 5.26396 4.65027 5.50063 4.88999C5.73744 5.12972 5.85584 5.41784 5.85584 5.75437C5.85584 6.09104 5.73598 6.3777 5.49626 6.61437C5.25653 6.85117 4.96841 6.96958 4.63188 6.96958Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export default RequirementsIcon;
